import { Component, OnInit } from '@angular/core';
import { OnboardingPageModel } from 'src/app/models/onboarding/onboarding-page.model';
import { LoadingService } from 'src/app/services/loading.service';
import { OnboardingFlowService } from 'src/app/services/onboarding/onboarding-flow.service';
import { SubscriptionService } from 'src/app/services/subscriptions/subscription.service';
import { TenantContextService } from 'src/app/services/tenant-context.service';
import { TenantSubscriptionService } from 'src/app/services/tenants/tenant-subscription.service';
import { TenantSubscriptionSummaryModel } from 'src/app/models/tenants/tenant-subscription-summary.model';
import { UserContextService } from 'src/app/services/user-context.service';

@Component({
  selector: 'app-onboarding-overlay',
  standalone: false,
  templateUrl: './onboarding-overlay.component.html',
  styleUrl: './onboarding-overlay.component.scss',
})
export class OnboardingOverlayComponent  implements OnInit {
  currentPage: OnboardingPageModel | null = null;
  index = 0;
  total = 0;
  isLast = false;

  showProvidedTenantSubscriptionModal: boolean = false;
  showContentUnlockedModal: boolean = false;

  providedTenantId: string | null = null;
  tenantSubscription: TenantSubscriptionSummaryModel | null = null

  providedTenantInvitedDate: Date | null = null;

  constructor(
    private onboardingFlow: OnboardingFlowService,
    private tenantContextService: TenantContextService,
    private tenantSubscriptionService: TenantSubscriptionService,
    private loadingService: LoadingService,
    private subscriptionService: SubscriptionService,
    private userContextService: UserContextService,
  ) {}

  ngOnInit(): void {
    const createdByTenantId = 
      this.tenantContextService.getCreatedByTenantId();
      
    if(createdByTenantId) {
      this.suggestProvidedTenantSubscription(createdByTenantId);
    } else {
      this.startOnboardingFlow();
    }
  }

  startOnboardingFlow() {
    this.onboardingFlow.loadPages().then(() => {
      this.renderStep();
    });
  }

  renderStep(): void {
    this.currentPage = this.onboardingFlow.getCurrent();
    this.index = this.onboardingFlow.getIndex();
    this.total = this.onboardingFlow.getTotal();
    this.isLast = this.index === this.total - 1;

    if (!this.currentPage) return;
    this.onboardingFlow.executeStep();
  }

  next(): void {
    if (this.isLast) {
      this.finish();
      return;
    }

    this.onboardingFlow.next();
    this.renderStep();
  }

  back(): void {
    this.onboardingFlow.back();
    this.renderStep();
  }

  skip(): void {
    this.finish();
  }

  finish(): void {
    this.onboardingFlow.completeOnboarding();
    this.currentPage = null;
  }

  suggestProvidedTenantSubscription(
    providedTenantId: string
  ): void {
    this.loadingService.load(
      this.tenantSubscriptionService.getTenantSubscriptionSummary(providedTenantId),
    ).subscribe((tenantSubscription) => {
      if(!tenantSubscription.tenantSubscription.publishToSubscribers) {
        this.startOnboardingFlow();
        return;
      }

      const consumerTenantId = this.tenantContextService.getTenantId();

      if (!consumerTenantId) {
        this.startOnboardingFlow();
        return;
      }
      
      this.loadingService.load(
        this.subscriptionService.getSubscription(
          providedTenantId, consumerTenantId
        )
      ).subscribe((subscription) => {
         if (subscription) {
          this.startOnboardingFlow();
          return;
        }

        this.showProvidedTenantSubscriptionModal = true;
        this.providedTenantId = providedTenantId;
        this.tenantSubscription = tenantSubscription;
        this.providedTenantInvitedDate = 
          this.userContextService.currentPerson?.createdAt ?? null;
      });
    })
  }

  subscribeToProvidedTenant(
    disabledStandardCategoryIds: string[]
  ) {
    if(!this.providedTenantId) return;

    this.loadingService.load(
      this.subscriptionService.subscribeToProvidedTenant(
        this.providedTenantId, disabledStandardCategoryIds
      )
    ).subscribe(() => {
      this.showContentUnlockedModal = true;
    });
  }

  onContentUnlockedContinue() {
    this.startOnboardingFlow();
  }

  skipSubscribingToProvidedTenant() {
    this.startOnboardingFlow();
  }
}
